import API, { handleRequest } from "./lib/api";

const buildQuery = (params = {}) => {
  const filtered = Object.entries(params).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      acc[key] = value;
    }
    return acc;
  }, {});

  const query = new URLSearchParams(filtered).toString();
  return query ? `?${query}` : "";
};

export const getNotificationsApi = (restaurantId, params = {}) =>
  handleRequest(() => {
    const query = buildQuery(params);
    return API.get(`/restaurant/${restaurantId}/notifications${query}`);
  });

export const updateNotificationsReadStatusApi = (restaurantId, payload) =>
  handleRequest(() =>
    API.put(`/restaurant/${restaurantId}/notifications/read-status`, payload)
  );
